import axios from "axios";
import environment from './environments/index';

const localBaseURL = environment.localApi?.dashboard;
const primaryBaseURL = environment.api.dashboard;
const shouldTryLocal = environment.env === "local" && Boolean(localBaseURL);

const instance = axios.create({
  baseURL: shouldTryLocal ? localBaseURL : primaryBaseURL,
});

instance.interceptors.request.use((config) => {
  return config;
});

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error?.config;
    const isNetworkError = !error?.response;
    if (shouldTryLocal && config && !config.__retryWithFallback && isNetworkError) {
      config.__retryWithFallback = true;
      config.baseURL = primaryBaseURL;
      return axios(config);
    }
    return Promise.reject(error);
  }
);

export default instance;
